(() => {
  const displayAnimationDuration = 200; // must be the same value as animation duration for `.announcement-bar-details-modal`
  const announcementBarDetailsModal = document.querySelector('.announcement-bar-details-modal');
  const announcementBarDetailsModalContent = document.querySelector('.announcement-bar-details-modal__content');
  const announcementBarDetailsModalCloseButton = document.querySelector('.announcement-bar-details-modal__content button');
  const announcementBarDetailsLink = document.querySelector('a.announcement-bar__details_link');
  let isOpened = false;

  const open = () => {
    isOpened = true;

    document.body.classList.add('with-modal');

    announcementBarDetailsModal.style.display = 'grid';
    setTimeout(() => {
      announcementBarDetailsModal.style.opacity = 1;
    });
  };

  const close = () => {
    isOpened = false;

    announcementBarDetailsModal.style.opacity = 0;
    setTimeout(() => {
      announcementBarDetailsModal.style.display = 'none';
      document.body.classList.remove('with-modal');
    }, displayAnimationDuration);
  };

  if (announcementBarDetailsLink) {
    announcementBarDetailsLink.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      open();
    });
  }

  announcementBarDetailsModalContent.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  announcementBarDetailsModalCloseButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    close();
  });

  announcementBarDetailsModal.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpened) {
      close();
    }
  });
})();
